import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div>
          <h1 className="not-found-title">404</h1>
          <h2 className="not-found-subtitle">Page not found</h2>
          <p className="not-found-description">
            Sorry, we couldn't find the page you're looking for.
          </p>
        </div>
        <div className="not-found-actions">
          <Link to="/">
            <button className="not-found-button not-found-button-primary">Go back home</button>
          </Link>
          <Link to="/login">
            <button className="not-found-button not-found-button-secondary">Log in</button>
          </Link>
        </div>
      </div>
    </div>
  )
}
